import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Grid, Autoplay, EffectFade } from 'swiper/modules';
function initSwiper(selector) {
    if (!selector) {
        return false;
    }
    return new Swiper(selector, {
        spaceBetween: 24,
        slidesPerView: 1,
        lazy: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        modules: [Navigation, EffectFade, Autoplay],
    });
}
function initSwiperRightAndLeft(selector1) {
    if (!selector1) {
        return false;
    }
    const swiperContainer = document.querySelector(selector1);
    const mySwiper = new Swiper(selector1, {
        modules: [Navigation, Autoplay],
        spaceBetween: 24,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        freeMode: true,
        speed: 5000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
    });
    const wrapper = document.querySelector(`${selector1} .swiper-wrapper`);
    let transformValue;
    wrapper &&
        wrapper.addEventListener('mouseenter', (event) => {
            if (wrapper instanceof HTMLElement) {
                mySwiper.autoplay.stop();
                transformValue = wrapper.style.transform;
                wrapper.style.transitionDuration = '0ms';
                wrapper.style.transform = `translate3d(${mySwiper.getTranslate()}px, 0px, 0px)`;
            }
        });
    wrapper &&
        wrapper.addEventListener('mouseleave', (event) => {
            if (wrapper instanceof HTMLElement) {
                wrapper.style.transitionDuration = `${mySwiper.params.speed}ms`;
                wrapper.style.transform = transformValue;
                mySwiper.autoplay.start();
            }
        });
}
function initSwiperPersonality() {
    const personalitySwiper = new Swiper('.personalitySwiper', {
        slidesPerView: 4,
        grid: {
            rows: 2,
        },
        direction: 'vertical',
        freeMode: true,
        watchSlidesProgress: true,
        modules: [Grid, Thumbs],
    });
    const personalitySwiper2 = new Swiper('.personalitySwiper2', {
        spaceBetween: 10,
        modules: [Thumbs],
        allowTouchMove: false,
        thumbs: {
            swiper: personalitySwiper,
        },
    });
    personalitySwiper.on('click', function () {
        const clickedSlideIndex = personalitySwiper.clickedIndex;
        const firstVisibleSlideIndex = personalitySwiper.activeIndex;
        const lastVisibleSlideIndex = personalitySwiper.activeIndex + personalitySwiper.params.slidesPerView - 1;
        if (clickedSlideIndex >= lastVisibleSlideIndex) {
            personalitySwiper.slideNext();
        }
        else if (clickedSlideIndex <= firstVisibleSlideIndex) {
            personalitySwiper.slidePrev();
        }
    });
}
function initSwiperLiterature() {
    return new Swiper('.js-swiper-lit', {
        spaceBetween: 32,
        slidesPerView: 4,
        lazy: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.js-swiper-lit-pagination',
        },
        navigation: {
            nextEl: '.js-swiper-lit-button-next',
            prevEl: '.js-swiper-lit-button-prev',
        },
        modules: [Navigation, Autoplay, Pagination],
    });
}
const Sliders = { initSwiper, initSwiperRightAndLeft, initSwiperPersonality, initSwiperLiterature };
export default Sliders;
